import styled from "styled-components";



export const EditorTree = styled.div`
    .topbar{
        padding: 10px 0;
       text-align: right; 
    }
    .message{
        padding:30px;
        text-align:center;
    }
    .tree-editor{
        background: #fff;
        border-radius: 10px;
        padding:10px 0px;
        
        ul{
            margin: 0;
            padding:0;
           
        }
        .root-list{
            border-top: 1px solid #dedede;
        }
       
        
        li{
            list-style: none;
        }
        
        .icon{
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .drag-icon{
            opacity: 0;
        }
        
        
        .tree-item{
           
            padding: 5px 0;
            border-bottom: 1px solid #dedede;
            display: flex;
            align-items: center;
            
            
            .label{
                display: flex;
                align-items: center;
                justify-content: flex-start;

                .id{
                    font-size:11px;
                    background: #dedede;
                    width: 30px;
                    height: 30px;
                    margin-right: 10px;
                    border-radius: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    line-height: 0;
                }
            }
            
            .actions{
                margin-left:10px;
                opacity: 0;
            }
            
            &:hover{
                background: #f2f2f2;
                .actions{
                    opacity: 1;
                }
                .drag-icon{
                    opacity: 1;
                }
            }
        }
        
        
        .toggle-icon{
            margin:0 15px 0 15px;
            width: 10px;
            height: 30px;
            border-radius: 50%;
            opacity: 0.4;
            
            
            &.hide{
                opacity: 0;
            }
            svg{
                
            }
            
            &.close{
                transform: rotate(-90deg);
            }
            
           
        }
    }
`;


export const DialogEditCategory = styled.div`
    min-height: 50px;
    min-width: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding:10px 10px;
    
    .rules{
        padding-top:20px;
        
        .help{
            font-size:12px;
            color:#888;
            margin:0;
            padding: 5px 0;
        }
    }

    .switch-control{
        padding-top:10px;
        width: 100%;
        label{
            display: block;
            width: 100%;
        }
    }
`;
